// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610090432/js/" + chunkId + "." + {"44":"03e9a684","225":"a126977f","481":"1dcf6b1a","486":"b7c79dc5","770":"e1abc13d"}[chunkId] + ".0.6787562635052302.chunk.js";
};